export default [
  {
    "desc": "app database opening error message",
    "en": "Error: Failed to open database. Beadographer will not work in Private Browsing Mode.",
    "fr": "Erreur : Impossible d'ouvrir la base de données. Beadographer ne fonctionne pas en mode navigation privée.",
    "da": "Fejl: Database kunne ikke åbnes. Beadographer virker ikke i privat browsing mode",
    "ro": "Eroare :Încercarea de a deschide baza de date a eșuat. Beadographer nu va funcționa în Modul Navigare Privată "
  },
  {
    "desc": "default palette color: white",
    "en": "White",
    "fr": "Blanc",
    "da": "Hvid",
    "ro": "Alb"
  },
  {
    "desc": "default palette color: grey",
    "en": "Grey",
    "fr": "Gris",
    "da": "Grå",
    "ro": "Gri"
  },
  {
    "desc": "default palette color: charcoal",
    "en": "Charcoal",
    "fr": "Charbon",
    "da": "Koksgrå",
    "ro": "Negru cărbune"
  },
  {
    "desc": "default palette color: red",
    "en": "Red",
    "fr": "Rouge",
    "da": "Rød",
    "ro": "Roșu"
  },
  {
    "desc": "default palette color: orange",
    "en": "Orange",
    "fr": "Orange",
    "da": "orange",
    "ro": "Portocaliu"
  },
  {
    "desc": "default palette color: gold",
    "en": "Gold",
    "fr": "Or",
    "da": "Guld",
    "ro": "Auriu"
  },
  {
    "desc": "default palette color: olive",
    "en": "Olive",
    "fr": "Olive",
    "da": "Oliven",
    "ro": "Măsliniu"
  },
  {
    "desc": "default palette color: lemon",
    "en": "Lemon",
    "fr": "Citron",
    "da": "Citron",
    "ro": "Galben lămâie"
  },
  {
    "desc": "default palette color: lime",
    "en": "Lime",
    "fr": "Citron vert",
    "da": "Lime",
    "ro": "Verde lime"
  },
  {
    "desc": "default palette color: green",
    "en": "Green",
    "fr": "Vert",
    "da": "Grøn",
    "ro": "Verde"
  },
  {
    "desc": "default palette color: aqua",
    "en": "Aqua",
    "fr": "Aqua",
    "da": "Blågrøn",
    "ro": "Albastru marin"
  },
  {
    "desc": "default palette color: cyan",
    "en": "Cyan",
    "fr": "Cyan",
    "da": "Cyan",
    "ro": "Turcoaz"
  },
  {
    "desc": "default palette color: blue",
    "en": "Blue",
    "fr": "Bleu",
    "da": "Blå",
    "ro": "Albastru"
  },
  {
    "desc": "default palette color: sapphire",
    "en": "Sapphire",
    "fr": "Saphir",
    "da": "Safirblå",
    "ro": "Albastru safir"
  },
  {
    "desc": "default palette color: deep blue",
    "en": "Deep Blue",
    "fr": "Bleu profond",
    "da": "Dybblå",
    "ro": "Albastru închis"
  },
  {
    "desc": "default palette color: purple",
    "en": "Purple",
    "fr": "Violet",
    "da": "Lilla",
    "ro": "Mov"
  },
  {
    "desc": "default palette color: magenta",
    "en": "Magenta",
    "fr": "Magenta",
    "da": "Magenta",
    "ro": "Magenta"
  },
  {
    "desc": "default palette color: rose",
    "en": "Rose",
    "fr": "Rose",
    "da": "Rosa",
    "ro": "Trandafiriu"
  },
  {
    "desc": "default palette color: pink",
    "en": "Pink",
    "fr": "Rose clair",
    "da": "Pink",
    "ro": "Roz"
  },
  {
    "desc": "default palette color: apricot",
    "en": "Apricot",
    "fr": "Abricot",
    "da": "Abrikos",
    "ro": "Roz piersică"
  },
  {
    "desc": "default palette color: sand",
    "en": "Sand",
    "fr": "Sable",
    "da": "Sand",
    "ro": "Bej"
  },
  {
    "desc": "default palette color: yellow",
    "en": "Yellow",
    "fr": "Jaune",
    "da": "Gul",
    "ro": "Galben"
  },
  {
    "desc": "default palette color: kiwi",
    "en": "Kiwi",
    "fr": "Kiwi",
    "da": "kiwi",
    "ro": "Verde kiwi"
  },
  {
    "desc": "default palette color: ocean",
    "en": "Ocean",
    "fr": "Ocean",
    "da": "Hav",
    "ro": "Albastru ocean"
  },
  {
    "desc": "default palette color: sky blue",
    "en": "Sky Blue",
    "fr": "Bleu ciel",
    "da": "Himmelblå",
    "ro": "Azur"
  },
  {
    "desc": "default palette color: cornflower",
    "en": "Cornflower",
    "fr": "Bleuet",
    "da": "Kornblomst",
    "ro": "Albastru pastel"
  },
  {
    "desc": "default palette color: pastel purple",
    "en": "Pastel Purple",
    "fr": "Violet pastel",
    "da": "Pastel lilla",
    "ro": "Mov pastel"
  },
  {
    "desc": "default palette color: pastel pink",
    "en": "Pastel Pink",
    "fr": "Rose pastel",
    "da": "Pastel pink",
    "ro": "Roz pastel"
  },
  {
    "desc": "default palette color: maroon",
    "en": "Maroon",
    "fr": "Bordeaux",
    "da": "Rødbrun",
    "ro": "Maro Burgundia"
  },
  {
    "desc": "default palette color: brown",
    "en": "Brown",
    "fr": "Brun",
    "da": "Brun",
    "ro": "Maro"
  },
  {
    "desc": "default palette color: forest green",
    "en": "Forest Green",
    "fr": "Vert forêt",
    "da": "Skovgrøn",
    "ro": "Verde pădure"
  },
  {
    "desc": "default palette color: cerulean",
    "en": "Cerulean",
    "fr": "Bleu azur",
    "da": "Himmelblå",
    "ro": "Albastru ca cerul"
  },
  {
    "desc": "auto color: red",
    "en": "red",
    "fr": "rouge",
    "da": "rød",
    "ro": "roșu"
  },
  {
    "desc": "auto color: red-orange",
    "en": "red-orange",
    "fr": "rouge-orangé",
    "da": "orangerød",
    "ro": "roșu-portocaliu"
  },
  {
    "desc": "auto color: orange",
    "en": "orange",
    "fr": "orange",
    "da": "orange",
    "ro": "portocaliu"
  },
  {
    "desc": "auto color: orange-yellow",
    "en": "orange-yellow",
    "fr": "Jaune-orange",
    "da": "orangegul",
    "ro": "portocaliu-galben"
  },
  {
    "desc": "auto color: yellow",
    "en": "yellow",
    "fr": "jaune",
    "da": "gul",
    "ro": "galben"
  },
  {
    "desc": "auto color: lime",
    "en": "lime",
    "fr": "citron vert",
    "da": "lime",
    "ro": "verde lime"
  },
  {
    "desc": "auto color: green",
    "en": "green",
    "fr": "vert",
    "da": "grøn",
    "ro": "verde"
  },
  {
    "desc": "auto color: green-blue",
    "en": "green-blue",
    "fr": "bleu-vert",
    "da": "grønblå",
    "ro": "verde-albastru"
  },
  {
    "desc": "auto color: cyan",
    "en": "cyan",
    "fr": "cyan",
    "da": "cyan",
    "ro": "turcoaz"
  },
  {
    "desc": "auto color: blue",
    "en": "blue",
    "fr": "bleu",
    "da": "blå",
    "ro": "albastru"
  },
  {
    "desc": "auto color: lavender",
    "en": "lavender",
    "fr": "lavande",
    "da": "lavendel",
    "ro": "mov lavandă"
  },
  {
    "desc": "auto color: magenta",
    "en": "magenta",
    "fr": "magenta",
    "da": "magenta",
    "ro": "magenta"
  },
  {
    "desc": "auto color: pink",
    "en": "pink",
    "fr": "rose",
    "da": "pink",
    "ro": "roz"
  },
  {
    "desc": "auto color: red",
    "en": "red",
    "fr": "rouge",
    "da": "rød",
    "ro": "roșu"
  },
  {
    "desc": "auto color: grey",
    "en": "grey",
    "fr": "gris",
    "da": "grå",
    "ro": "gri"
  },
  {
    "desc": "auto color: faint",
    "en": "faint",
    "fr": "léger",
    "da": "svag",
    "ro": "deschis"
  },
  {
    "desc": "auto color: pastel",
    "en": "pastel",
    "fr": "pastel",
    "da": "pastel",
    "ro": "pastel"
  },
  {
    "desc": "auto color: vibrant",
    "en": "vibrant",
    "fr": "éclatant",
    "da": "stærk",
    "ro": "vibrant"
  },
  {
    "desc": "auto color: black",
    "en": "black",
    "fr": "noir",
    "da": "sort",
    "ro": "negru"
  },
  {
    "desc": "auto color: murky",
    "en": "murky",
    "fr": "sombre",
    "da": "støvet",
    "ro": "închis"
  },
  {
    "desc": "auto color: dark",
    "en": "dark",
    "fr": "foncé",
    "da": "sort",
    "ro": "întunecat"
  },
  {
    "desc": "auto color: fairly dark",
    "en": "fairly dark",
    "fr": "assez sombre",
    "da": "middel mørk",
    "ro": "mai întunecat"
  },
  {
    "desc": "auto color: pale",
    "en": "pale",
    "fr": "pâle",
    "da": "lys",
    "ro": "pal"
  },
  {
    "desc": "auto color: very pale",
    "en": "very pale",
    "fr": "très pâle",
    "da": "meget lys",
    "ro": "foarte pal"
  },
  {
    "desc": "auto color: off-white",
    "en": "off-white",
    "fr": "blanc cassé",
    "da": "off-white",
    "ro": "alb-murdar"
  },
  {
    "desc": "auto color: white",
    "en": "white",
    "fr": "blanc",
    "da": "hvid",
    "ro": "alb"
  },
  {
    "desc": "auto color: olive",
    "en": "olive",
    "fr": "olive",
    "da": "oliven",
    "ro": "măsliniu"
  },
  {
    "desc": "auto color: brown",
    "en": "brown",
    "fr": "marron",
    "da": "brun",
    "ro": "maro"
  },
  {
    "desc": "auto color: maroon",
    "en": "maroon",
    "fr": "bordeaux",
    "da": "rødbrun",
    "ro": "maro Burgundia"
  },
  {
    "desc": "ruler cm units",
    "en": "cm",
    "fr": "cm",
    "da": "cm",
    "ro": "cm"
  },
  {
    "desc": "ruler inches unit",
    "en": "\"",
    "fr": "in.",
    "da": "tommer",
    "ro": "inci"
  },
  {
    "desc": "created",
    "en": "created",
    "fr": "créé",
    "da": "oprettet",
    "ro": "creat"
  },
  {
    "desc": "updated",
    "en": "updated",
    "fr": "mis à jour",
    "da": "opdateret",
    "ro": "actualizat"
  },
  {
    "desc": "default project name",
    "en": "Untitled Project",
    "fr": "Sans Titre",
    "da": "Unavngivet projekt",
    "ro": "Proiect fără titlu"
  },
  {
    "desc": "name duplicate prompt",
    "en": "Enter name of copy",
    "fr": "Nom de la copie",
    "da": "Indsæt navn på kopi",
    "ro": "Introduceți numele copiei"
  },
  {
    "desc": "rename file prompt",
    "en": "Enter new file name",
    "fr": "Nouveau nom",
    "da": "Indsæt nyt fil navn",
    "ro": "Introduceți noul nume al fișierului"
  },
  {
    "desc": "delete project prompt",
    "en": "Delete this project?",
    "fr": "Supprimer ce projet ?",
    "da": "Slet dette projekt",
    "ro": "Ștergeți acest proiect?"
  },
  {
    "desc": "delete multiple projects prompt",
    "en": "Delete projects?",
    "fr": "Supprimer ces projets ?",
    "da": "Slet projekter?",
    "ro": "Ștergeți proiectele?"
  },
  {
    "desc": "sort projects by name",
    "en": "name",
    "fr": "nom",
    "da": "navn",
    "ro": "nume"
  },
  {
    "desc": "sort projects by date created",
    "en": "date created",
    "fr": "date de création",
    "da": "dato oprettet",
    "ro": "data creării"
  },
  {
    "desc": "sort projects by date modified",
    "en": "date modified",
    "fr": "date de modif.",
    "da": "dato opdateret",
    "ro": "data modificării"
  },
  {
    "desc": "auto theme option",
    "en": "Auto",
    "fr": "Auto",
    "da": "Automatisk",
    "ro": "Auto"
  },
  {
    "desc": "reset editor warning message",
    "en": "Any changes to the word chart will be lost. Continue?",
    "fr": "Toute modification de la trame lettrée sera perdue. Continuer ?",
    "da": "Ændringer til instruktioner slettes. Vil du fortsætte?",
    "ro": "Orice schimbare asupra diagramei de cuvinte va fi pierdută. Continuați?"
  },
  {
    "desc": "created message",
    "en": "Created with Beadographer on",
    "fr": "Dessiné avec Beadographer le",
    "da": "Oprettet med Beadographer d.",
    "ro": "Creat cu Beadographer în data de"
  },
  {
    "desc": "created by placeholder text",
    "en": "Created by ...",
    "fr": "Dessiné par ...",
    "da": "Oprettet af",
    "ro": "Creat de"
  },
  {
    "desc": "rows",
    "en": "rows",
    "fr": "rangs",
    "da": "rækker",
    "ro": "rânduri"
  },
  {
    "desc": "columns",
    "en": "columns",
    "fr": "colonnes",
    "da": "kolonner",
    "ro": "coloane"
  },
  {
    "desc": "project dimensions",
    "en": "project dimensions",
    "fr": "dimensions",
    "da": "projekt dimensioner",
    "ro": "dimensiunea proiectului"
  },
  {
    "desc": "cm",
    "en": "cm",
    "fr": "cm",
    "da": "cm",
    "ro": "cm"
  },
  {
    "desc": "inches",
    "en": "inches",
    "fr": "in.",
    "da": "tommer",
    "ro": "inci"
  },
  {
    "desc": "bead",
    "en": "bead",
    "fr": "perle",
    "da": "perle",
    "ro": "mărgea"
  },
  {
    "desc": "beads",
    "en": "beads",
    "fr": "perles",
    "da": "perler",
    "ro": "mărgele"
  },
  {
    "desc": "symbol",
    "en": "Symbol",
    "fr": "Symbole",
    "da": "Symbol",
    "ro": "Simbol"
  },
  {
    "desc": "count",
    "en": "count",
    "fr": "quantité",
    "da": "antal",
    "ro": "numărătoare"
  },
  {
    "desc": "description",
    "en": "Description",
    "fr": "Description",
    "da": "Beskrivelse",
    "ro": "Descriere"
  },
  {
    "desc": "tags",
    "en": "tags",
    "fr": "balises",
    "da": "tags",
    "ro": "etichete"
  },
  {
    "desc": "tags separated by commas",
    "en": "Tags separated by commas",
    "fr": "Balises séparées par des virgules",
    "da": "Tags adskilt af kommaer",
    "ro": "Etichetele separate de virgule"
  },
  {
    "desc": "credits",
    "en": "Credits",
    "fr": "Crédits",
    "da": "Kreditter",
    "ro": "Drepturi de autor"
  },
  {
    "desc": "beading instructions",
    "en": "Beading Instructions",
    "fr": "Instructions de perlage",
    "da": "Perlevejledning",
    "ro": "Instrucțiuni pentru mărgelit"
  },
  {
    "desc": "bead list pdf title",
    "en": "Bead List",
    "fr": "Liste des perles",
    "da": "Perle oversigt",
    "ro": "Lista mărgelelor"
  },
  {
    "desc": "row",
    "en": "row",
    "fr": "rang",
    "da": "række",
    "ro": "rând"
  },
  {
    "desc": "space between beads explanation on pdf export",
    "en": "space between beads",
    "fr": "espace entre les perles (trous)",
    "da": "afstand mellem perler",
    "ro": "spațiu între mărgele"
  },
  {
    "desc": "rows 1 and 2",
    "en": "rows 1 and 2",
    "fr": "rangs 1 et 2",
    "da": "række 1 og 2",
    "ro": "rândurile 1 și 2"
  },
  {
    "desc": "pattern diagram",
    "en": "Pattern Diagram",
    "fr": "Diagramme",
    "da": "Mønster Diagram",
    "ro": "diagrama schemă"
  },
  {
    "desc": "referring to a panel in pdf export",
    "en": "for panel",
    "fr": "pour le panneau",
    "da": "til felt",
    "ro": "pentru panou"
  },
  {
    "desc": "referring to a warped square in pdf export",
    "en": "for warped square",
    "fr": "pour le warped square",
    "da": "til warped square",
    "ro": "pentru forme geometrice pliate"
  },
  {
    "desc": "word chart",
    "en": "Word Chart",
    "fr": "Trame Lettrée",
    "da": "Instruktioner",
    "ro": "diagramă de cuvinte"
  },
  {
    "desc": "bead library add to favorites",
    "en": "Add to favorites",
    "fr": "Ajouter aux favoris",
    "da": "Føj til favoritter",
    "ro": "Adaugă la favorite"
  },
  {
    "desc": "bead library swap in selected style",
    "en": "Swap in selected style",
    "fr": "Remplacer par cette couleur",
    "da": "Skift til valgte perle",
    "ro": "Schimbați în stilul ales"
  },
  {
    "desc": "bead library add style to palette",
    "en": "Add style to palette",
    "fr": "Ajouter cette couleur à la palette",
    "da": "Tilføj perle til paletten",
    "ro": "Adăugați stilul la paleta de culori"
  },
  {
    "desc": "search the bead library",
    "en": "Search the bead library",
    "fr": "Chercher dans le catalogue de perles",
    "da": "Søg efter perle i kataloget",
    "ro": "Caută în librăria de mărgele"
  },
  {
    "desc": "show your favorites",
    "en": "Show your favorites",
    "fr": "Montrer favoris",
    "da": "Se favoritter",
    "ro": "Arată favoritele tale"
  },
  {
    "desc": "show",
    "en": "Show",
    "fr": "Montrer",
    "da": "Se",
    "ro": "Arată"
  },
  {
    "desc": "change patterns warning",
    "en": "Changing patterns may result in lost beads. Please duplicate your project to back up your file before proceeding.",
    "fr": "Changer de motif risque de perdre des perles. Pensez à dupliquer votre projet avant pour en conserver une copie",
    "da": "Skift af mønster kan resultere i tabte perler. Husk venligst at kopiere dine projekter til en backup fil før du fortsætter.",
    "ro": "Modificarea modelelor poate cauza pierderea unor mărgele. Vă rugăm duplicați proiectul pentru a avea o copie de rezervă înainte de a continua"
  },
  {
    "desc": "delete beads warning",
    "en": "Beads may be deleted. This cannot be undone.",
    "fr": "Des perles vont être perdues de façon irréversible.",
    "da": "Perler vil blive slettet. Dette kan ikke fortrydes.",
    "ro": "Mărgelele pot fi șterse. Acest lucru nu poate fi anulat"
  },
  {
    "desc": "project updated notice",
    "en": "Project updated",
    "fr": "Projet mis à jour",
    "da": "Projektet er opdateret",
    "ro": "Proiect actualizat"
  },
  {
    "desc": "new bead soup created notice",
    "en": "New bead soup created",
    "fr": "Nouvelle soupe de perles créée",
    "da": "Nyt perlemix er oprettet",
    "ro": "Amestec nou de mărgele creat"
  },
  {
    "desc": "export table description of project image",
    "en": "This is the image of the entire project",
    "fr": "Ceci est l'image d'ensemble du projet",
    "da": "Dette er billedet af hele projektet",
    "ro": "Aceasta este imaginea întregului proiect"
  },
  {
    "desc": "export table description of bead list",
    "en": "This lists all the beads in the project",
    "fr": "Liste de toutes les perles du projet",
    "da": "Denne liste indeholder alle perler i projektet",
    "ro": "Aceasta listează toate mărgelele din proiect"
  },
  {
    "desc": "export table description of diagrams",
    "en": "The diagrams for the project",
    "fr": "Les diagrammes du projet",
    "da": "Diagram for projektet",
    "ro": "Diagramele proiectului"
  },
  {
    "desc": "export table description of word charts",
    "en": "The word charts for the project",
    "fr": "La trame lettrée du projet",
    "da": "Instruktioner for projektet",
    "ro": "Diagramele de cuvinte ale proiectului"
  },
  {
    "desc": "export table description of my image",
    "en": "An image that you have uploaded below under 'My Images'",
    "fr": "Une image que vous avez chargée par l'option 'mes images' ci-dessous",
    "da": "Et billede, som du har uploadet under 'Mine billeder'",
    "ro": "O imagine pe care ai încărcat-o mai jos în 'Imaginile mele'"
  },
  {
    "desc": "export table type: title",
    "en": "Title",
    "fr": "Titre",
    "da": "Overskrift",
    "ro": "Titlu"
  },
  {
    "desc": "export table type: subtitle",
    "en": "Subtitle",
    "fr": "Sous-titre",
    "da": "Undertitel",
    "ro": "Subtitlu"
  },
  {
    "desc": "export table type: paragraph",
    "en": "Paragraph",
    "fr": "Paragraphe",
    "da": "Afsnit",
    "ro": "Paragraf"
  },
  {
    "desc": "export table type: project image",
    "en": "Project image",
    "fr": "Image du projet",
    "da": "Projekt billede",
    "ro": "Imaginea proiectului"
  },
  {
    "desc": "export table type: bead list",
    "en": "Bead list",
    "fr": "Liste des perles",
    "da": "Perle oversigt",
    "ro": "Lista mărgelelor"
  },
  {
    "desc": "export table type: diagrams",
    "en": "Diagrams",
    "fr": "Diagrammes",
    "da": "Diagrammer",
    "ro": "Diagrame"
  },
  {
    "desc": "export table type: word charts",
    "en": "Word charts",
    "fr": "Trame lettrée",
    "da": "Instruktioner",
    "ro": "Diagrame de cuvinte"
  },
  {
    "desc": "export table type: my image",
    "en": "My image",
    "fr": "Mon image",
    "da": "Mit billede",
    "ro": "Imaginea mea"
  },
  {
    "desc": "new bead",
    "en": "New Bead",
    "fr": "Nouveau Perle",
    "da": "Ny Perle",
    "ro": "Mărgea nouă"
  },
  {
    "desc": "color",
    "en": "Color",
    "fr": "Couleur",
    "da": "Farve",
    "ro": "Culoare"
  },
  {
    "desc": "finish",
    "en": "finish",
    "fr": "finition",
    "da": "Afslut",
    "ro": "finisaj"
  },
  {
    "desc": "transparency",
    "en": "transparency",
    "fr": "transparence",
    "da": "gennemsigtighed",
    "ro": "transparență"
  },
  {
    "desc": "bead count",
    "en": "Bead count",
    "fr": "Nombre de perles",
    "da": "Antal perler",
    "ro": "Număr de mărgele"
  },
  {
    "desc": "title",
    "en": "Title",
    "fr": "Titre",
    "da": "Overskrift",
    "ro": "Titlu"
  },
  {
    "desc": "library",
    "en": "Library",
    "fr": "Catalogue",
    "da": "Kartotek",
    "ro": "Librărie"
  },
  {
    "desc": "number of styles",
    "en": "number of styles",
    "fr": "nombre de teintes",
    "da": "antal farvekoder",
    "ro": "numărul de stiluri"
  },
  {
    "desc": "date created",
    "en": "date created",
    "fr": "date de création",
    "da": "oprettelsedato",
    "ro": "data creării"
  },
  {
    "desc": "export table select row",
    "en": "Select",
    "fr": "Choisir",
    "da": "Vælg",
    "ro": "Selectați"
  },
  {
    "desc": "export table type",
    "en": "Type",
    "fr": "Type",
    "da": "Element",
    "ro": "Tipul"
  },
  {
    "desc": "export table break",
    "en": "Break",
    "fr": "Rupture",
    "da": "Ny side",
    "ro": "Pauză"
  },
  {
    "desc": "export table text content",
    "en": "Text content",
    "fr": "Contenu texte",
    "da": "Tekst indhold",
    "ro": "Conținutul textului"
  },
  {
    "desc": "pattern",
    "en": "pattern",
    "fr": "motif",
    "da": "mønster",
    "ro": "model"
  },
  {
    "desc": "size",
    "en": "size",
    "fr": "taille",
    "da": "størrelse",
    "ro": "mărime"
  },
  {
    "desc": "modified",
    "en": "modified",
    "fr": "modifié",
    "da": "opdateret",
    "ro": "modificat"
  },
  {
    "desc": "continue project tab title",
    "en": "Continue working on",
    "fr": "Reprendre le travail sur",
    "da": "Fortsæt arbejdet med",
    "ro": "Continuați să lucrați la"
  },
  {
    "desc": "enter palette name prompt",
    "en": "Enter palette name",
    "fr": "Entrez un nom de palette",
    "da": "Indsæt palettens navn",
    "ro": "Introduceți numele paletei de culori"
  },
  {
    "desc": "clear unused swatches warning",
    "en": "Clear all unused swatches? This cannot be undone.",
    "fr": "Effacer toutes les nuances inutilisées ? Ceci est irrémédiable.",
    "da": "Slet alle ubrugte farver? Dette kan ikke fortrydes.",
    "ro": "Ștergeți toate mostrele de mărgele neutilizate? Acest lucru nu poate fi anulat."
  },
  {
    "desc": "palette set as default notice",
    "en": "Palette set as default",
    "fr": "Palette utilisée par défaut",
    "da": "Palette sat som standard",
    "ro": "Paletă de culori aleasă ca implicită"
  },
  {
    "desc": "default palette reset notice",
    "en": "Default palette reset",
    "fr": "Palette par défaut réinitialisée",
    "da": "Standard palette nulstillet",
    "ro": "Resetarea paletei de culori implicită"
  },
  {
    "desc": "enter project key prompt",
    "en": "Enter project key",
    "fr": "Entrez la clé de référence du projet",
    "da": "Indsæt projekt kode",
    "ro": "Introduceți codul proiectului"
  },
  {
    "desc": "more styles button tooltip",
    "en": "Show more styles",
    "fr": "Montrer plus de nuances",
    "da": "Vis flere farvekoder",
    "ro": "Arată mai multe stiluri"
  },
  {
    "desc": "active style bead tooltip",
    "en": "Active style",
    "fr": "Nuance active",
    "da": "Aktiv farvekode",
    "ro": "Stilul activ"
  },
  {
    "desc": "hue slider tooltip",
    "en": "Set the hue of the active style.",
    "fr": "Réglez la teinte de la nuance active.",
    "da": "Sæt farvetonen på den aktive farvekode",
    "ro": "Setează nuanța stilului activ."
  },
  {
    "desc": "saturation slider tooltip",
    "en": "Set the saturation of the active style.",
    "fr": "Réglez la saturation de la nuance active.",
    "da": "Sæt farvemætning på den aktive farvekode",
    "ro": "Setează saturația stilului activ."
  },
  {
    "desc": "luminance slider tooltip",
    "en": "Set the luminosity of the active style.",
    "fr": "Réglez la luminosité de la nuance active.",
    "da": "Sæt lysstyrken på den aktive farvekode",
    "ro": "Setează luminozitatea stilului activ."
  },
  {
    "desc": "matte finish tooltip",
    "en": "Add a matte finish to the active style.",
    "fr": "Ajoutez une finition mate à la nuance active.",
    "da": "Tilføj en mat overflade til den aktive farvekode",
    "ro": "Adaugă finisaj mat stilului activ."
  },
  {
    "desc": "semi-gloss finish tooltip",
    "en": "Add a semi-gloss finish to the active style.",
    "fr": "Ajoutez une finition semi-brillante à la nuance active.",
    "da": "Tilføj en halv-mat overflade til den aktive farvekode",
    "ro": "Adaugă finisaj semi-lucios stilului activ."
  },
  {
    "desc": "gloss finish tooltip",
    "en": "Add a gloss finish to the active style.",
    "fr": "Ajoutez une finition brillante à la nuance active.",
    "da": "Tilføj en blank overflade til den aktive farvekode",
    "ro": "Adaugă finisaj lucios stilului activ."
  },
  {
    "desc": "opaque finish tooltip",
    "en": "Make the active style opaque.",
    "fr": "Rendez la nuance active opaque.",
    "da": "Lav den aktive farvekode uigennemsigtig",
    "ro": "Fă stilul activ opac."
  },
  {
    "desc": "transparent finish tooltip",
    "en": "Make the active style transparent.",
    "fr": "Rendez la nuance active transparente.",
    "da": "Lav den aktive farvekode gennemsigtig",
    "ro": "Fă stilul activ transparent. "
  },
  {
    "desc": "inside color finish tooltip",
    "en": "Make the active style transparent with inside color.",
    "fr": "Rendez la nuance active transparente, avec un couleur interne.",
    "da": "Lav den aktive farvekode gennemsigtig med indvendig farve",
    "ro": "Fă stilul activ transparent cu interior colorat."
  },
  {
    "desc": "add style tooltip",
    "en": "Add style to palette",
    "fr": "Ajouter la nuance à la palette",
    "da": "Føj farvekode til paletten",
    "ro": "Adaugă stilul la paleta de culori"
  },
  {
    "desc": "toggle secondary color button tooltip",
    "en": "Toggle secondary color slider",
    "fr": "Activation du curseur de seconde couleur",
    "da": "Skift til sekundære farvevælger",
    "ro": "Mișcați cursorul culorii secundare"
  },
  {
    "desc": "match styles warning",
    "en": "All swatch descriptions will be overwritten. Continue?",
    "fr": "Toutes les descriptions des nuances seront effacées. Continuer ?",
    "da": "Alle farvekoder vil blive overskrevet. Vil du fortsætte?",
    "ro": "Toate descrierile mostrelor de mărgele vor fi suprascrise. Continuați?"
  },
  {
    "desc": "light theme option",
    "en": "Light",
    "fr": "Léger",
    "da": "Lys",
    "ro": "Luminos"
  },
  {
    "desc": "dark theme option",
    "en": "Dark",
    "fr": "Sombre",
    "da": "Mørk",
    "ro": "Întunecat"
  },
  {
    "desc": "menu tool tip",
    "en": "Menu",
    "fr": "Menu",
    "da": "Menu",
    "ro": "Meniu"
  },
  {
    "desc": "draw tool tip",
    "en": "Draw Tool",
    "fr": "outil de Dessin",
    "da": "Tegne perler",
    "ro": "Unealta de desen"
  },
  {
    "desc": "erase tool tip",
    "en": "Erase Tool",
    "fr": "outil Effacer",
    "da": "Slette perler",
    "ro": "Unealta de șters"
  },
  {
    "desc": "hand tool tip",
    "en": "Hand Tool",
    "fr": "outil Main",
    "da": "Hånd redskab",
    "ro": "Unealta mână"
  },
  {
    "desc": "open color pickers tool tip",
    "en": "Open Color Pickers",
    "fr": "Ouvrir les sélecteurs de couleurs",
    "da": "Åbn farvevælgere",
    "ro": "Deschideți selectoarele de culoare"
  },
  {
    "desc": "bead library tool tip",
    "en": "Bead Library",
    "fr": "Catalogue de perles",
    "da": "Perle kartotek",
    "ro": "Librăria de mărgele"
  },
  {
    "desc": "zoom in tool tip",
    "en": "Zoom in",
    "fr": "Zoom avant",
    "da": "zoom ind",
    "ro": "Mărește"
  },
  {
    "desc": "zoom out tool tip",
    "en": "Zoom out",
    "fr": "Zoom arrière",
    "da": "Zoom ud",
    "ro": "Micșorează"
  },
  {
    "desc": "undo tool tip",
    "en": "Undo",
    "fr": "Défaire",
    "da": "Fortryd",
    "ro": "Anulează"
  },
  {
    "desc": "redo tool tip",
    "en": "Redo",
    "fr": "Refaire",
    "da": "Gentag",
    "ro": "Refă"
  },
  {
    "desc": "share tool tip",
    "en": "Share a screenshot",
    "fr": "Copie d'écran",
    "da": "Del et skærmbillede",
    "ro": "Distribuie o captură de ecran"
  },
  {
    "desc": "marquee tool tip",
    "en": "Marquee Tool",
    "fr": "outil Marquise",
    "da": "Markeringsredskab",
    "ro": "Unealta marcaj"
  },
  {
    "desc": "select tool tip",
    "en": "Select Tool",
    "fr": "outil Sélection",
    "da": "Vælg perle",
    "ro": "Unealta selecție"
  },
  {
    "desc": "color select tool tip",
    "en": "Color Select Tool",
    "fr": "outil Couleur",
    "da": "Vælg farvekoder",
    "ro": "Unealta de selecție a culorii"
  },
  {
    "desc": "bead mode tool tip",
    "en": "Beading Tool",
    "fr": "Mode de perlage",
    "da": "Perlesyning markørredskab",
    "ro": "Unealta de mărgelit"
  },
  {
    "desc": "paint tool tip",
    "en": "Paint Tool",
    "fr": "outil Peinture",
    "da": "Fyld sammenhængende felter med farvekode",
    "ro": "Unealta de pictură"
  },
  {
    "desc": "rectangle tool tip",
    "en": "Rectangle Tool",
    "fr": "outil Rectangle",
    "da": "Fyld markeret rektangel med farvekode",
    "ro": "Unealta dreptunghi"
  },
  {
    "desc": "image tool tip",
    "en": "Image Tool",
    "fr": "outil Image",
    "da": "Billede ",
    "ro": "Unealta imagine"
  },
  {
    "desc": "mirror tool tip",
    "en": "Mirror Tool",
    "fr": "outil Miroir",
    "da": "Symmetri",
    "ro": "Unealta oglindă"
  },
  {
    "desc": "soup tool tip",
    "en": "Bead Soup Tool",
    "fr": "outil Soupe de perles",
    "da": "Perlemix",
    "ro": "Unealta amestec de mărgele"
  },
  {
    "desc": "ruler tool tip",
    "en": "Ruler",
    "fr": "Règle",
    "da": "Lineal",
    "ro": "Riglă"
  },
  {
    "desc": "eyedropper tool tip",
    "en": "Eyedropper",
    "fr": "Compte-gouttes",
    "da": "Vælg farvekode",
    "ro": "Pipetă"
  },
  {
    "desc": "row shift tool tip",
    "en": "Row Shift",
    "fr": "Glisser une rangée",
    "da": "Ryk række",
    "ro": "Schimbarea rândului"
  },
  {
    "desc": "star tool tip",
    "en": "Star",
    "fr": "Outil étoile",
    "da": "Stjerne",
    "ro": "Stea"
  },
  {
    "desc": "show more tool tip",
    "en": "More Tools",
    "fr": "Plus d'outils",
    "da": "Flere redskaber",
    "ro": "Mai multe unelte"
  },
  {
    "desc": "rotate right tool tip",
    "en": "Rotate right",
    "fr": "Tourner à droite",
    "da": "Drej til højre",
    "ro": "Rotește spre dreapta"
  },
  {
    "desc": "rotate left tool tip",
    "en": "Rotate left",
    "fr": "Tourner à gauche",
    "da": "Drej til venstre",
    "ro": "Rotește spre stânga"
  },
  {
    "desc": "rotate 180 degrees tool tip",
    "en": "Rotate 180 degrees",
    "fr": "Tourner de 180 degrés",
    "da": "Drej 180 grader",
    "ro": "Rotește 180 de grade"
  },
  {
    "desc": "flip horizontal tool tip",
    "en": "Flip horizontal",
    "fr": "Renverser horizontalement",
    "da": "Spejlvend vandret",
    "ro": "Întoarce orizontal"
  },
  {
    "desc": "flip vertical tool tip",
    "en": "Flip vertical",
    "fr": "Renverser verticalement",
    "da": "Spejlvend lodret",
    "ro": "Întoarce vertical"
  },
  {
    "desc": "erase selected tool tip",
    "en": "Erase Selected",
    "fr": "Effacer la sélection",
    "da": "Slet valgte",
    "ro": "Ștergere selectată"
  },
  {
    "desc": "download bead list tool tip",
    "en": "Download bead list",
    "fr": "Télécharger la liste des perles",
    "da": "Download perlelisten",
    "ro": "Descarcă lista de mărgele"
  },
  {
    "desc": "show hide guides",
    "en": "Show/hide guides",
    "fr": "Montrer/cacher les guides",
    "da": "Vis/skjul retningslinjer",
    "ro": "Arată/ascunde ghidajele"
  },
  {
    "desc": "show hide symbols tool tip",
    "en": "Show/hide symbols",
    "fr": "Montrer/cacher les symboles de couleur",
    "da": "Vis/skjul symboler",
    "ro": "Arată/ascunde simbolurile"
  },
  {
    "desc": "show hide inactive beads tool tip",
    "en": "Show/hide inactive beads",
    "fr": "Montrer/cacher les emplacements inutilisés",
    "da": "Vis/skjul tomme felter",
    "ro": "Arată/ascunde mărgelele inactive"
  },
  {
    "desc": "show hide rendering tool tip",
    "en": "Show/hide rendering",
    "fr": "Montrer/cacher le rendu réaliste",
    "da": "Vis/Skjul gengivelse",
    "ro": "Arată/ascunde afișarea"
  },
  {
    "desc": "beading mode move row back",
    "en": "Move beading row back",
    "fr": "Déplacer le rang en arrière",
    "da": "Gå en række tilbage",
    "ro": "Mută rândul de mărgele în spate"
  },
  {
    "desc": "beading mode move row forwards",
    "en": "Move beading row",
    "fr": "Déplacer le rang en avant",
    "da": "Gå en række frem",
    "ro": "Mută rândul de mărgele"
  },
  {
    "desc": "beading mode change direction",
    "en": "Change direction",
    "fr": "Changer de direction",
    "da": "Skift syretning",
    "ro": "Schimbă direcția"
  },
  {
    "desc": "dismiss bead cat button",
    "en": "OK",
    "fr": "OK",
    "da": "OK",
    "ro": "OK"
  },
  {
    "desc": "hide bead cat button",
    "en": "Hide me",
    "fr": "Cachez moi",
    "da": "Skjul mig",
    "ro": "Ascunde-mă"
  },
  {
    "desc": "meow",
    "en": "Meow!",
    "fr": "Miaou !",
    "da": "Miaw",
    "ro": "Miau!"
  },
  {
    "desc": "delete image tool tip",
    "en": "Delete image",
    "fr": "Effacer l'image",
    "da": "Slet billede",
    "ro": "Șterge imaginea"
  },
  {
    "desc": "convert to beads tool tip",
    "en": "Convert to beads",
    "fr": "Convertir en perles",
    "da": "Omdan til perler",
    "ro": "Convertește în mărgele"
  },
  {
    "desc": "would like hints button",
    "en": "OK",
    "fr": "Oui",
    "da": "OK",
    "ro": "OK"
  },
  {
    "desc": "would not like hints button",
    "en": "No",
    "fr": "Non",
    "da": "Nej",
    "ro": "Nu"
  },
  {
    "desc": "splash screen title",
    "en": "Beadographer",
    "fr": "Beadographer",
    "da": "Beadographer",
    "ro": "Beadographer"
  },
  {
    "desc": "start beading button",
    "en": "Start Beading",
    "fr": "Commencez à perler",
    "da": "Start perlesyningen",
    "ro": "Începe mărgelitul"
  },
  {
    "desc": "free version",
    "en": "Free Version",
    "fr": "Version Gratuite",
    "da": "Gratis Version",
    "ro": "Versiune gratuită"
  },
  {
    "desc": "not logged in message",
    "en": "You are not logged in.",
    "fr": "Vous n'êtes pas connecté.",
    "da": "Du er ikke logget ind.",
    "ro": "Nu ești autentificat."
  },
  {
    "desc": "log in button",
    "en": "Log in",
    "fr": "Se connecter",
    "da": "Log på",
    "ro": "Autentificare"
  },
  {
    "desc": "one moment",
    "en": "One moment...",
    "fr": "Un moment...",
    "da": "Vent et øjeblik...",
    "ro": "Un moment..."
  },
  {
    "desc": "learn more button",
    "en": "Sign up",
    "fr": "S'inscrire",
    "da": "Tilmelde",
    "ro": "Înscrie-te"
  },
  {
    "desc": "loading message",
    "en": "Loading...",
    "fr": "Chargement...",
    "da": "Indlæser...",
    "ro": "Se încarcă..."
  },
  {
    "desc": "open button",
    "en": "Open",
    "fr": "Ouvrir",
    "da": "Åben",
    "ro": "Deschide"
  },
  {
    "desc": "rename button",
    "en": "Rename",
    "fr": "Renommer",
    "da": "Omdøb",
    "ro": "Redenumește"
  },
  {
    "desc": "duplicate project",
    "en": "Duplicate",
    "fr": "Dupliquer",
    "da": "Kopier",
    "ro": "Fă o copie"
  },
  {
    "desc": "download button",
    "en": "Download",
    "fr": "Télécharger",
    "da": "Hent",
    "ro": "Descarcă"
  },
  {
    "desc": "cancel",
    "en": "Cancel",
    "fr": "Annuler",
    "da": "Annuler",
    "ro": "Anulează"
  },
  {
    "desc": "delete",
    "en": "Delete",
    "fr": "Effacer",
    "da": "Slet",
    "ro": "Șterge"
  },
  {
    "desc": "modal OK button",
    "en": "OK",
    "fr": "OK",
    "da": "OK",
    "ro": "OK"
  },
  {
    "desc": "edit swatch dialog title",
    "en": "Edit Swatch",
    "fr": "Editer une nuance",
    "da": "Rediger farvekode",
    "ro": "Editează mostra"
  },
  {
    "desc": "edit swatch description",
    "en": "Description",
    "fr": "Description",
    "da": "Beskrivelse",
    "ro": "Descriere"
  },
  {
    "desc": "edit swatch color",
    "en": "Color",
    "fr": "Couleur",
    "da": "Farve",
    "ro": "Culoare"
  },
  {
    "desc": "edit swatch use second color checkbox",
    "en": "Use second color?",
    "fr": "Utiliser une seconde couleur ?",
    "da": "Bruge sekundær farvekode",
    "ro": "Utilizați o culoare secundară?"
  },
  {
    "desc": "edit swatch second color",
    "en": "Second color",
    "fr": "Seconde couleur",
    "da": "Sekundær farve",
    "ro": "Culoare secundară"
  },
  {
    "desc": "edit swatch finish",
    "en": "Finish",
    "fr": "Terminer",
    "da": "Afslut",
    "ro": "Finisaj"
  },
  {
    "desc": "edit swatch matte",
    "en": "Matte",
    "fr": "Mat",
    "da": "Mat",
    "ro": "Mat"
  },
  {
    "desc": "edit swatch semi-gloss",
    "en": "Semi-Gloss",
    "fr": "Semi-brillant",
    "da": "Halvglans",
    "ro": "Semi-lucios"
  },
  {
    "desc": "edit swatch gloss",
    "en": "Gloss",
    "fr": "Brillant",
    "da": "Glans",
    "ro": "Lucios"
  },
  {
    "desc": "edit swatch transparency",
    "en": "Transparency",
    "fr": "Transparence",
    "da": "Gennemsigtlighed",
    "ro": "Transparență"
  },
  {
    "desc": "edit swatch opaque",
    "en": "Opaque",
    "fr": "Opaque",
    "da": "Ugennemsigtig",
    "ro": "Opac"
  },
  {
    "desc": "edit swatch transparent",
    "en": "Transparent",
    "fr": "Transparent",
    "da": "Gennemsigtig",
    "ro": "Transparent"
  },
  {
    "desc": "edit swatch inner color",
    "en": "Inner Color",
    "fr": "Couleur interne",
    "da": "Inderste farve",
    "ro": "Culoare interioară"
  },
  {
    "desc": "edit swatch symbol",
    "en": "Symbol",
    "fr": "Symbole",
    "da": "Symbol",
    "ro": "Simbol"
  },
  {
    "desc": "edit swatch save button",
    "en": "Save",
    "fr": "Enregistrer",
    "da": "Gem",
    "ro": "Salvează"
  },
  {
    "desc": "delete swatch button",
    "en": "Delete",
    "fr": "Effacer la nuance",
    "da": "Slet farvekode",
    "ro": "Șterge"
  },
  {
    "desc": "convert image dialog title",
    "en": "Convert Image",
    "fr": "Convertir l'image",
    "da": "Omdan billede",
    "ro": "Convertește imaginea"
  },
  {
    "desc": "convert image number of colors",
    "en": "Number of Colors",
    "fr": "Nombre de couleurs",
    "da": "Antal farver",
    "ro": "Numărul de culori"
  },
  {
    "desc": "convert image use only palette",
    "en": "Use only styles in palette",
    "fr": "Utiliser seulement les nuances de la palette",
    "da": "brug kun farvekoder i paletten",
    "ro": "Folosește doar stilurile din paleta de culori"
  },
  {
    "desc": "convert image use only palette tip",
    "en": "Converts using the styles you already have in your palette.",
    "fr": "Limite la conversion aux nuances figurant dans la palette.",
    "da": "Omdanner med farvekoder der allerede findes i paletten",
    "ro": "Convertește folosind stiluri pe care le ai deja în paleta ta de culori"
  },
  {
    "desc": "convert image conversion method",
    "en": "Conversion Method:",
    "fr": "Méthode de conversion :",
    "da": "Omdannelsesmetode",
    "ro": "Metoda de conversie"
  },
  {
    "desc": "convert image rgb method",
    "en": "RGB",
    "fr": "RGB",
    "da": "RGB",
    "ro": "RGB"
  },
  {
    "desc": "convert image hsv method",
    "en": "HSV",
    "fr": "HSV",
    "da": "HSV",
    "ro": "HSV"
  },
  {
    "desc": "convert image conversion method tip",
    "en": "The method by which the app compares colors during the conversion process. Use RGB by default.",
    "fr": "Définit la méthode utilisée pour comparer les couleurs lors de la conversion. Par défaut, utilisez RGB.",
    "da": "Den metode app'en bruger til at omdanne farverne i omdannelsesprocessen. Brug RGB som standard.",
    "ro": "Metoda prin care aplicația compară culorile în timpul procesului de conversie. Folosește RGB ca metodă implicită"
  },
  {
    "desc": "convert image convert button",
    "en": "Convert",
    "fr": "Convertir",
    "da": "Omdan",
    "ro": "Convertește"
  },
  {
    "desc": "exit menu",
    "en": "Exit Menu",
    "fr": "Sortir du menu",
    "da": "Afslut Menu",
    "ro": "Ieși din meniu"
  },
  {
    "desc": "upgrade tab",
    "en": "Upgrade",
    "fr": "Mise à jour",
    "da": "Opgradering",
    "ro": "Actualizare"
  },
  {
    "desc": "new project tab",
    "en": "New",
    "fr": "Nouveau",
    "da": "Ny",
    "ro": "Nou"
  },
  {
    "desc": "edit project tab",
    "en": "Edit",
    "fr": "Modifier",
    "da": "Rediger",
    "ro": "Editează"
  },
  {
    "desc": "my projects tab",
    "en": "My Projects",
    "fr": "Mes projets",
    "da": "Mine projekter",
    "ro": "Proiectele mele"
  },
  {
    "desc": "palette tab",
    "en": "Palette",
    "fr": "Palette",
    "da": "Palette",
    "ro": "Paleta de culori"
  },
  {
    "desc": "settings tab",
    "en": "Settings",
    "fr": "Réglages",
    "da": "Opsætning",
    "ro": "Setări"
  },
  {
    "desc": "word chart tab",
    "en": "Word Chart",
    "fr": "Trame lettrée",
    "da": "Instruktioner",
    "ro": "Diagramă de cuvinte"
  },
  {
    "desc": "export tab",
    "en": "Export PDF",
    "fr": "Exporter PDF",
    "da": "Eksport PDF",
    "ro": "Exportă PDF"
  },
  {
    "desc": "help tab",
    "en": "Help",
    "fr": "Aide",
    "da": "Hjælp",
    "ro": "Ajutor"
  },
  {
    "desc": "continue project title",
    "en": "Continue working on My test",
    "fr": "Continuer à travailler avec My test",
    "da": "Fortsæt med at arbejde på Min test",
    "ro": "Continuă să lucrezi la Testul meu"
  },
  {
    "desc": "continue project button",
    "en": "Continue",
    "fr": "Continuer",
    "da": "Fortsæt",
    "ro": "Continuă"
  },
  {
    "desc": "new project title",
    "en": "New Project",
    "fr": "Nouveau projet",
    "da": "Nyt projekt",
    "ro": "Proiect nou"
  },
  {
    "desc": "project title text input",
    "en": "Project Title",
    "fr": "Titre du projet",
    "da": "Projekt Titel",
    "ro": "Titlul proiectului"
  },
  {
    "desc": "bead library selection",
    "en": "Bead Library",
    "fr": "Catalogue de perles",
    "da": "Perle katalog",
    "ro": "Librăria de mărgele"
  },
  {
    "desc": "bead library selection tip",
    "en": "Choose the beads you will work with.",
    "fr": "Choisissez les perles avec lesquelles vous allez travailler.",
    "da": "Vælg de perler du vil arbejde med",
    "ro": "Alege mărgelele cu care vei lucra."
  },
  {
    "desc": "pattern selection",
    "en": "Pattern",
    "fr": "Motif",
    "da": "Diagram",
    "ro": "Model"
  },
  {
    "desc": "pattern selection tip",
    "en": "Choose the layout of the beads.",
    "fr": "Définissez la disposition des perles.",
    "da": "Vælg opsætning af perlerne.",
    "ro": "Alege așezarea mărgelelor."
  },
  {
    "desc": "rows number input",
    "en": "Rows",
    "fr": "Rangs",
    "da": "Rækker",
    "ro": "Rânduri"
  },
  {
    "desc": "columns number input",
    "en": "Columns",
    "fr": "Colonnes",
    "da": "Kolonner",
    "ro": "Coloane"
  },
  {
    "desc": "size number input",
    "en": "Size",
    "fr": "Taille",
    "da": "Størrelse",
    "ro": "Mărimea"
  },
  {
    "desc": "use custom bead size",
    "en": "Use custom bead size",
    "fr": "Utiliser une taille spécifique de perles",
    "da": "Brug individuel perle størrelse",
    "ro": "Folosește o mărime specială de mărgele"
  },
  {
    "desc": "bead diameter number input",
    "en": "Bead diameter (mm)",
    "fr": "Diamètre des perles (mm)",
    "da": "Perle diameter (mm)",
    "ro": "Diametrul mărgelei (mm)"
  },
  {
    "desc": "bead width number input",
    "en": "Bead width (mm)",
    "fr": "Largeur des perles (mm)",
    "da": "Perle bredde (mm)",
    "ro": "Lățimea mărgelei (mm)"
  },
  {
    "desc": "aspect ratio",
    "en": "Aspect ratio:",
    "fr": "Rapport largeur/diamètre :",
    "da": "Billedformat",
    "ro": "Aspectul proporțiilor"
  },
  {
    "desc": "aspect ratio warning",
    "en": "Bead width must be between 50-100% of bead diameter.                    ",
    "fr": "La largeur des perles doit être entre 50% et 100% de leur diamètre",
    "da": "Perlebredde skal være mellem 50-100% af diameteren.",
    "ro": "Lățimea mărgelei trebuie să fie între 50-100% din diametrul mărgelei"
  },
  {
    "desc": "project size title",
    "en": "Project size",
    "fr": "Taille du projet",
    "da": "Projekt størrelse",
    "ro": "Mărimea proiectului"
  },
  {
    "desc": "size warning",
    "en": "This will be a large project. Beadographer may run slowly, depending on device memory.                ",
    "fr": "C'est un projet de grande taille. Beadographer peut vous paraître lent, selon la taille de la mémoire disponible.",
    "da": "Dette vil blive et stort projekt. Beadographer kan arbejde langsomt afhængig af enhedens hukommelse.",
    "ro": "Acesta va fi un proiect mare. E posibil ca Beadographer să ruleze mai încet, în funcție de memoria dispozitivului. "
  },
  {
    "desc": "launch project button",
    "en": "Launch",
    "fr": "Lancer",
    "da": "Start",
    "ro": "Lansează"
  },
  {
    "desc": "edit project title",
    "en": "Edit Project",
    "fr": "Modifier le projet",
    "da": "Rediger projekt",
    "ro": "Editează proiectul"
  },
  {
    "desc": "rename styles question",
    "en": "Rename styles?",
    "fr": "Renommer les nuances ?",
    "da": "Omdøb farvekoder",
    "ro": "Redenumești stilurile?"
  },
  {
    "desc": "rename styles tip",
    "en": "This will replace the description of each swatch with a generic color description.",
    "fr": "Ceci va remplacer les descriptions des nuances par une description générique de la couleur.",
    "da": "Dette vil erstatte beskrivelsen af hver farvekode med en generisk farvebeskrivelse.",
    "ro": "Acest lucru va înlocui descrierea fiecărei mărgele-mostră cu o denumire generică a culorii."
  },
  {
    "desc": "update project button",
    "en": "Update Project",
    "fr": "Mettre à jour le projet",
    "da": "Opdater projektet",
    "ro": "Actualizează proiectul"
  },
  {
    "desc": "update project button tip",
    "en": "You must click this button to apply any changes you made above.",
    "fr": "Cliquez sur ce bouton pour appliquer les changements apportés ci-dessus.",
    "da": "Klik på denne knap for at gennemføre ændringer foretaget overfor.",
    "ro": "Trebuie să apeși acest buton pentru a aplica orice modificare făcută mai sus"
  },
  {
    "desc": "actions",
    "en": "Actions",
    "fr": "Actions",
    "da": "Aktiviteter",
    "ro": "Acțiuni"
  },
  {
    "desc": "trim project button",
    "en": "Trim Project",
    "fr": "Rogner le projet",
    "da": "Trim projektet",
    "ro": "Taie marginile proiectului"
  },
  {
    "desc": "trim project button tip",
    "en": "Removes any empty rows and columns around your project.",
    "fr": "Retire les lignes et colonnes vides autour de votre projet.",
    "da": "Fjerner alle tomme rækker og kolonner omkring dit projekt.",
    "ro": "Îndepărtează orice rânduri sau coloane goale din jurul proiectului"
  },
  {
    "desc": "get project code button",
    "en": "Get Project Code",
    "fr": "Obtenir un code projet",
    "da": "Hent en projektkode",
    "ro": "Obține codul proiectului"
  },
  {
    "desc": "get project code button tip",
    "en": "Get a shareable link for this project. Projects can then be loaded with this code on another device. Links expire in 1 year.",
    "fr": "Obtenir un lien partageable pour ce projet. Ce lien permet ensuite de charger le projet sur un autre appareil. Les liens expirent au bout d'un an.",
    "da": "Opret et delbart link til dette projekt. Projekter kan derefter hentes med denne kode på enhver anden enhed. Links udløber efter et år",
    "ro": "Obține un link care se poate distribui pentru acest proiect. Proiectele pot fi apoi încărcate cu acest cod pe alt dispozitiv. Linkurile expiră după 1 an."
  },
  {
    "desc": "my projects title",
    "en": "My Projects",
    "fr": "Mes projets",
    "da": "Mine Projekter",
    "ro": "Proiectele mele"
  },
  {
    "desc": "thumbnail view button",
    "en": "Thumbnail view",
    "fr": "Vue en miniatures",
    "da": "Miniaturebillede oversigt",
    "ro": "Vizualizare în miniatură"
  },
  {
    "desc": "list view button",
    "en": "List view",
    "fr": "Vue en liste",
    "da": "Liste oversigt",
    "ro": "Vizualizare listă"
  },
  {
    "desc": "upload",
    "en": "Upload",
    "fr": "Charger",
    "da": "Hent",
    "ro": "Încarcă"
  },
  {
    "desc": "load from code button",
    "en": "Load from code",
    "fr": "Utiliser un code de partage",
    "da": "Åbn fra kode",
    "ro": "Încarcă cu ajutorul unui cod"
  },
  {
    "desc": "backup button",
    "en": "Backup",
    "fr": "Sauvegarder",
    "da": "Backup",
    "ro": "Fă o copie de rezervă"
  },
  {
    "desc": "backup warning",
    "en": "Important! Backup to protect your work",
    "fr": "Important ! Sauvegarder pour archiver votre travail.",
    "da": "Vigtig! Backup for at beskytte dit arbejde",
    "ro": "Important! Fă copii de rezervă pentru a-ți proteja munca"
  },
  {
    "desc": "delete selected projects button",
    "en": "Delete selected projects",
    "fr": "Effacer le ou les projets sélectionnés",
    "da": "Slet valgte projekter",
    "ro": "Șterge proiectele selectate"
  },
  {
    "desc": "sort by",
    "en": "Sort by ",
    "fr": "Trier par",
    "da": "Sorter på",
    "ro": "Sortează în funcție de"
  },
  {
    "desc": "name sort option",
    "en": "name",
    "fr": "nom",
    "da": "navn",
    "ro": "nume"
  },
  {
    "desc": "date modified sort option",
    "en": "date modified",
    "fr": "date de modif.",
    "da": "ændringsdato",
    "ro": "data modificării"
  },
  {
    "desc": "date created sort option",
    "en": "date created",
    "fr": "date de création",
    "da": "oprettelsedato",
    "ro": "data creării"
  },
  {
    "desc": "recent first",
    "en": "Recent first",
    "fr": "Récent",
    "da": "Seneste først",
    "ro": "Cele mai noi primele"
  },
  {
    "desc": "oldest first",
    "en": "Oldest first",
    "fr": "Ancien",
    "da": "Ældste først",
    "ro": "Cele mai vechi primele"
  },
  {
    "desc": "no description",
    "en": "(No description)",
    "fr": "(Pas de description)",
    "da": "(Ingen beskrivelse)",
    "ro": "(Fără descriere)"
  },
  {
    "desc": "no credits",
    "en": "(No credits)",
    "fr": "(Pas de crédits)",
    "da": "(Ingen kreditter)",
    "ro": "Fără drepturi de autor"
  },
  {
    "desc": "no instructions",
    "en": "(No instructions)",
    "fr": "(Pas de instructions)",
    "da": "(Ingen instruktioner)",
    "ro": "(Fără instrucțiuni)"
  },
  {
    "desc": "enter title placeholder",
    "en": "Enter title here",
    "fr": "Entrez le titre ici",
    "da": "Indtast titel her",
    "ro": "Introduceți titlul aici"
  },
  {
    "desc": "enter description placeholder",
    "en": "Enter description here",
    "fr": "Entrez la description ici",
    "da": "Indtast beskrivelse her",
    "ro": "Introduceți descrierea aici"
  },
  {
    "desc": "enter credits placeholder",
    "en": "Enter credits here",
    "fr": "Entrez les crédits ici",
    "da": "Indtast kreditter her",
    "ro": "Introduceți acreditarea/ drepturile de autor aici"
  },
  {
    "desc": "beading instructions placeholder",
    "en": "Enter beading instructions here",
    "fr": "Entrez les instructions de perlage ici",
    "da": "Indtast perlevejledning her",
    "ro": "Introduceți instrucțiunile pentru mărgelit aici"
  },
  {
    "desc": "save changes",
    "en": "Save changes",
    "fr": "Sauvegarder les modifications",
    "da": "Gem ændringer",
    "ro": "Salvați modificările"
  },
  {
    "desc": "sort button",
    "en": "Sort",
    "fr": "Trier",
    "da": "Sorter",
    "ro": "Sortează"
  },
  {
    "desc": "palette settings title",
    "en": "Palette settings",
    "fr": "Réglages de la palette",
    "da": "Palette opsætninger",
    "ro": "Setările paletei de culori"
  },
  {
    "desc": "delete unused swatches",
    "en": "Delete unused swatches",
    "fr": "Effacer les nuances inutilisées",
    "da": "Slet ubrugte farvekoder",
    "ro": "Ștergeți mostrele de mărgele nefolosite"
  },
  {
    "desc": "delete selected swatches",
    "en": "Delete selected swatches",
    "fr": "Effacer les nuances sélectionnées",
    "da": "Slet valgte farvekoder",
    "ro": "Ștergeți mostrele de mărgele selectate"
  },
  {
    "desc": "create bead soup",
    "en": "Create Bead Soup",
    "fr": "Créer une soupe",
    "da": "Skab et perlemix",
    "ro": "Crează un amestec de mărgele"
  },
  {
    "desc": "save palette",
    "en": "Save palette",
    "fr": "Enregistrer la palette",
    "da": "Gem palette",
    "ro": "Salvează paleta de culori"
  },
  {
    "desc": "auto assign symbols",
    "en": "Auto-assign symbols",
    "fr": "Assigner automatiquement des symboles",
    "da": "Tilføj automatisk symboler",
    "ro": "Atribuie automat simbolurile"
  },
  {
    "desc": "match swatches to library",
    "en": "Match styles to library",
    "fr": "Chercher les correspondances dans le catalogue",
    "da": "Tilpas farvekoder til kataloget",
    "ro": "Potrivește stilurile la librăria de mărgele"
  },
  {
    "desc": "my saved palettes title",
    "en": "My saved palettes",
    "fr": "Mes palettes enregistrées",
    "da": "Mine gemte paletter",
    "ro": "Paletele mele de culori salvate"
  },
  {
    "desc": "load selected palette",
    "en": "Append selected palettes",
    "fr": "Charger la palette sélectionnée",
    "da": "Indsæt valgte palette",
    "ro": "Adaugă paletele de culori selectate"
  },
  {
    "desc": "delete selected palette",
    "en": "Delete selected palette",
    "fr": "Effacer la palette sélectionnée",
    "da": "Slet valgte palette",
    "ro": "Șterge paleta de culori selectată"
  },
  {
    "desc": "set palette as default",
    "en": "Set palette as default",
    "fr": "Définir comme palette par défaut",
    "da": "Sæt denne palette som standard",
    "ro": "Setează paleta de culori ca implicită"
  },
  {
    "desc": "clear default palette",
    "en": "Clear default palette",
    "fr": "Annuler la palette par défaut",
    "da": "Slet standard palette",
    "ro": "Șterge paleta de culori implicită"
  },
  {
    "desc": "settings title",
    "en": "Settings",
    "fr": "Réglages",
    "da": "Opsætning",
    "ro": "Setări"
  },
  {
    "desc": "theme selection",
    "en": "Theme",
    "fr": "Thème",
    "da": "Tema",
    "ro": "Temă"
  },
  {
    "desc": "units selection",
    "en": "Units",
    "fr": "Unités",
    "da": "Enheder",
    "ro": "Unități de măsură"
  },
  {
    "desc": "show pointer coordinates",
    "en": "Show pointer coordinates",
    "fr": "Montrer les coordonnés du pointeur",
    "da": "Vis markør koordinater",
    "ro": "Arată coordonatele indicatorului "
  },
  {
    "desc": "show bead symbols",
    "en": "Show bead symbols",
    "fr": "Montrer les symboles des perles",
    "da": "Vis perle symboler",
    "ro": "Arată simbolurile mărgelelor"
  },
  {
    "desc": "show inactive beads",
    "en": "Show inactive beads",
    "fr": "Montrer les emplacements inutilisés",
    "da": "Vis inactive perler",
    "ro": "Arată mărgelele inactive"
  },
  {
    "desc": "render as simple blocks",
    "en": "Render as simple blocks",
    "fr": "Afficher comme de simples blocs",
    "da": "Gengiv som flade farver",
    "ro": "Afișează ca dreptunghiuri simple"
  },
  {
    "desc": "show bead cat",
    "en": "Show Bead Cat",
    "fr": "Montrer Bead Cat",
    "da": "Vis Perle katten",
    "ro": "Arată Pisica Mărgelelor"
  },
  {
    "desc": "show bead cat on start",
    "en": "Show Bead Cat on start",
    "fr": "Montrer Bead Cat au démarrage",
    "da": "Vis Perle katten ved opstart",
    "ro": "Arată Pisica Mărgelelor la start"
  },
  {
    "desc": "enable mouse scroll",
    "en": "Enable mouse scroll",
    "fr": "Autoriser les déplacements à la molette",
    "da": "Aktiver scroll med musen",
    "ro": "Activează derularea cu mouse-ul"
  },
  {
    "desc": "canvas image",
    "en": "Canvas Image",
    "fr": "Image du canevas",
    "da": "Diagram billede",
    "ro": "Imagine canvas"
  },
  {
    "desc": "load image button",
    "en": "Load Image",
    "fr": "Charger une image",
    "da": "Hent Billede",
    "ro": "Încarcă imaginea"
  },
  {
    "desc": "guides title",
    "en": "Guides",
    "fr": "Lignes guides",
    "da": "Retningslinjer",
    "ro": "Ghidaje"
  },
  {
    "desc": "show guides",
    "en": "Show guides",
    "fr": "Montrer les guides",
    "da": "Vis retningslinjer",
    "ro": "Arată ghidajele"
  },
  {
    "desc": "horizontal guide spacing",
    "en": "Horizontal guide spacing",
    "fr": "Espacement horizontal",
    "da": "Afstand mellem vandrette retningslinjer",
    "ro": "Distanța orizontală dintre ghidaje"
  },
  {
    "desc": "vertical guide spacing",
    "en": "Vertical guide spacing",
    "fr": "Espacement vertical",
    "da": "Afstand mellem vandrette retningslinjer",
    "ro": "Distanța verticală dintre ghidaje"
  },
  {
    "desc": "guide color option",
    "en": "Color",
    "fr": "Couleur",
    "da": "Farve",
    "ro": "Culoare"
  },
  {
    "desc": "word chart format button: heading",
    "en": "Heading",
    "fr": "En-tête",
    "da": "Overskrift",
    "ro": "Titlu"
  },
  {
    "desc": "word chart format button: bold",
    "en": "Bold",
    "fr": "Gras",
    "da": "Fed",
    "ro": "Îngroșat"
  },
  {
    "desc": "reset word chart",
    "en": "Reset Word Chart",
    "fr": "Réinitialiser la trame lettrée",
    "da": "Gendan instruktioner",
    "ro": "Resetează diagrama de cuvinte"
  },
  {
    "desc": "export project title",
    "en": "Export your project",
    "fr": "Exporter votre projet",
    "da": "Eksporter dit projekt",
    "ro": "Exportă proiectul"
  },
  {
    "desc": "pdf contents title",
    "en": "PDF Contents",
    "fr": "Contenu du PDF",
    "da": "PDF indhold",
    "ro": "Conținutul PDF-ului"
  },
  {
    "desc": "export tip 1",
    "en": "This table shows the contents of your exported PDF.",
    "fr": "Ce tableau liste les éléments constitutifs du fichier PDF",
    "da": "Denne tabel viser indholdet af din eksporterede PDF.",
    "ro": "Acest tabel arată conținutul PDF-ului exportat."
  },
  {
    "desc": "export tip 2",
    "en": "Click on any text content to edit.",
    "fr": "Cliquez sur un texte pour le modifier",
    "da": "Klik på tekst for at redigere den.",
    "ro": "Dă click pe oricare din conținutul textului pentru a edita."
  },
  {
    "desc": "export tip 3",
    "en": "Move a row by clicking and dragging its handle in the first column.",
    "fr": "Déplacez une rangée en cliquant et tirant son marqueur en première colonne.",
    "da": "Flyt en række ved at klikke og trække dens håndtag i første kolonne.",
    "ro": "Mută un rând dând click și trăgându-l de mânerul din prima coloană."
  },
  {
    "desc": "export tip 4",
    "en": "A tick in the 'Break' column indicates that a page break will be inserted before the element.",
    "fr": "Une coche dans la colonne 'Rupture' indique qu'un saut de page sera inséré avant cet élément.",
    "da": "Et flueben i 'Sideskift' kolonnen indikerer at et sideskift vil indsættes før elementet.",
    "ro": "O bifă în coloana 'Pauză' arată că o pagină pauză va fi inserată înaintea elementului."
  },
  {
    "desc": "add row button",
    "en": "Add Row",
    "fr": "Ajouter une ligne",
    "da": "Tilføj række",
    "ro": "Adaugă un rând"
  },
  {
    "desc": "delete selected rows button",
    "en": "Delete Selected Rows",
    "fr": "Effacer la ou les lignes sélectionnées",
    "da": "Slet valgte rækker",
    "ro": "Șterge rândurile selectate"
  },
  {
    "desc": "reset export table button",
    "en": "Reset Table",
    "fr": "Réinitialiser la table",
    "da": "Gendan tabellen",
    "ro": "Resetează tabelul"
  },
  {
    "desc": "options",
    "en": "Options",
    "fr": "Options",
    "da": "Muligheder",
    "ro": "Opțiuni"
  },
  {
    "desc": "image options area",
    "en": "Image",
    "fr": "Images",
    "da": "Billede",
    "ro": "Imagine"
  },
  {
    "desc": "text options area",
    "en": "Text",
    "fr": "Textes",
    "da": "Tekst",
    "ro": "Text"
  },
  {
    "desc": "page options area",
    "en": "Page",
    "fr": "Page",
    "da": "Side",
    "ro": "Pagină"
  },
  {
    "desc": "use custom word chart",
    "en": "Use custom word chart",
    "fr": "Utiliser la trame lettrée modifiée",
    "da": "Anvend brugerdefinerede instruktioner",
    "ro": "Folosește o diagramă de cuvinte personalizată "
  },
  {
    "desc": "use custom word chart tip",
    "en": "Uses the contents of the text editor in the Word Chart tab.",
    "fr": "Utilise le contenu de l'éditeur de texte dans l'onglet Trame Lettrée",
    "da": "Anvender indholdet fra tekstbehandlingen i Instruktioner tab'en.",
    "ro": "Folosește conținutul editorului de text în diagrama de cuvinte."
  },
  {
    "desc": "use panels",
    "en": "Split project into panels ",
    "fr": "Diviser le projet en panneaux",
    "da": "Del projektet ind i paneler.",
    "ro": "Împarte proiectul în panouri"
  },
  {
    "desc": "use panels tip",
    "en": "Panels split large canvases up into smaller chunks. Recommended for large projects like tapestries",
    "fr": "Les panneaux divisent un grand projet en unités plus faciles à gérer. Recommandé pour les grandes surface telles que des tapisseries.",
    "da": "Paneler deler store diagrammer op i mindre dele. Dette er anbefalet ved projekter så som vægbilleder",
    "ro": "Panourile împart imaginile mari în bucăți mai mici. Recomandat pentru proiecte mari cum ar fi tapiseriile"
  },
  {
    "desc": "max panel width",
    "en": "Max panel width",
    "fr": "Largeur maximale des panneaux",
    "da": "Maximun panel bredde",
    "ro": "Lățimea maximă a panoului"
  },
  {
    "desc": "starting bead",
    "en": "Starting bead ",
    "fr": "Perle de démarrage",
    "da": "Start perle",
    "ro": "Mărgeaua de început"
  },
  {
    "desc": "starting bead tip",
    "en": "This is the first bead you will pick up when making your design. For peyote, make sure your starting bead is a 'down' bead.",
    "fr": "C'est la perle par laquelle vous débuterez votre travail. Pour le peyote pensez à choisir une perle 'basse'.",
    "da": "Dette er den første perle, du vil samle op for at begynde dit design. Sørg for at dette er en 'down' perle for peyote.",
    "ro": "Aceasta este prima mărgea pe care o înșiri atunci când realizezi proiectul. La tehnica Peyote, asigură-te că mărgeaua de început e una de jos. "
  },
  {
    "desc": "top left",
    "en": "Top left",
    "fr": "En haut, à gauche",
    "da": "Øverst til venstre",
    "ro": "Sus în stânga"
  },
  {
    "desc": "top right",
    "en": "Top right",
    "fr": "En haut, à droite",
    "da": "Øverst til højre",
    "ro": "Sus în dreapta"
  },
  {
    "desc": "bottom left",
    "en": "Bottom left",
    "fr": "En bas, à gauche",
    "da": "Nederst til venstre",
    "ro": "Jos în stânga"
  },
  {
    "desc": "bottom right",
    "en": "Bottom right",
    "fr": "En bas, à droite",
    "da": "Nederst til højre",
    "ro": "Jos în dreapta"
  },
  {
    "desc": "beading direction",
    "en": "Beading direction",
    "fr": "Sens de perlage",
    "da": "Sy retning",
    "ro": "Direcția de mărgelit"
  },
  {
    "desc": "horizontal",
    "en": "Horizontal",
    "fr": "Horizontal",
    "da": "Vandret",
    "ro": "Orizontal"
  },
  {
    "desc": "vertical",
    "en": "Vertical",
    "fr": "Vertical",
    "da": "Lodret",
    "ro": "Vertical"
  },
  {
    "desc": "alternate row direction",
    "en": "Alternate row direction",
    "fr": "Alterner la direction à chaque rang",
    "da": "Rækker frem og tilbage",
    "ro": "Alternează direcția rândurilor"
  },
  {
    "desc": "tubular peyote",
    "en": "Tubular peyote",
    "fr": "Peyote tubulaire",
    "da": "Rørformet peyote",
    "ro": "Peyote tubular"
  },
  {
    "desc": "header image file input",
    "en": "Header Image ",
    "fr": "Image d'en-tête",
    "da": "Billed til sidehoved",
    "ro": "Imagine copertă"
  },
  {
    "desc": "header image file input tip",
    "en": "This image will be placed at the top-right hand corner of the first page only.                            ",
    "fr": "Cette image sera placée à l'angle en haut à droite de la première page.",
    "da": "Dette billede vil kun vises i øverste højre hjørne af første side.",
    "ro": "Această imagine va fi plasată doar în colțul din dreapta sus pe prima pagină."
  },
  {
    "desc": "clear header image button",
    "en": "Clear Header Image",
    "fr": "Effacer l'image d'en-tête",
    "da": "Slet billed I sidehoved",
    "ro": "Șterge imaginea copertă"
  },
  {
    "desc": "my images file input",
    "en": "My Images ",
    "fr": "Mes images",
    "da": "Mine billeder",
    "ro": "Imaginile mele"
  },
  {
    "desc": "my images file input tip",
    "en": "You can select multiple images to add to the PDF. You will need to add a shortcode for each image in the editor on the “Template” tab.",
    "fr": "Vous pouvez sélectionner plusieurs images à inclure dans le PDF. Il vous faudra ajouter une shortcode pour chaque image dans l'éditeur de texte.",
    "da": "Du kan vælge at indsætte flere billeder til PDF'en. Der skal bruges en shortcode til hvert billede i tekst editor.",
    "ro": "Poți selecta imagini multiple pentru a le adăuga la PDF. Va trebui să adaugi un cod scurt pentru fiecare imadine în editor in fila 'Șablon'."
  },
  {
    "desc": "footer text",
    "en": "Footer text ",
    "fr": "Texte en bas de page",
    "da": "Sidefodstekst",
    "ro": "Text de subsol"
  },
  {
    "desc": "custom text 1",
    "en": "Custom text 1 ",
    "fr": "Texte personnalisé 1",
    "da": "Brugerdefineret tekst 1",
    "ro": "Text personalizat 1"
  },
  {
    "desc": "custom text 2",
    "en": "Custom text 2 ",
    "fr": "Texte personnalisé 2",
    "da": "Brugerdefineret tekst 2",
    "ro": "Text personalizat 2"
  },
  {
    "desc": "custom text 3",
    "en": "Custom text 3 ",
    "fr": "Texte personnalisé 3",
    "da": "Brugerdefineret tekst 3",
    "ro": "Text personalizat 3"
  },
  {
    "desc": "use small diagram",
    "en": "Use small diagram",
    "fr": "Utiliser un diagramme compact",
    "da": "Brug lille diagram",
    "ro": "Folosește diagrama mică "
  },
  {
    "desc": "page size selection",
    "en": "Page size ",
    "fr": "Taille du papier",
    "da": "Side størrelse",
    "ro": "Mărimea paginii"
  },
  {
    "desc": "letter page size",
    "en": "Letter",
    "fr": "Lettre",
    "da": "Letter",
    "ro": "Scrisoare"
  },
  {
    "desc": "A4 page size",
    "en": "A4",
    "fr": "A4",
    "da": "A4",
    "ro": "A4"
  },
  {
    "desc": "create pdf button",
    "en": "Create PDF",
    "fr": "Créer le PDF",
    "da": "Skab PDF",
    "ro": "Creează PDF"
  },
  {
    "desc": "please wait message",
    "en": "This may take a few minutes...",
    "fr": "Ceci peut prendre du temps...",
    "da": "Dette kan vare et par minutter...",
    "ro": "Acest lucru poate dura câteva minute..."
  },
  {
    "desc": "help title",
    "en": "Beadographer Help",
    "fr": "Aide pour Beadographer",
    "da": "Hjælp til Beadographer",
    "ro": "Ajutor Beadographer"
  },
  {
    "desc": "help intro",
    "en": "These resources will help you get started using Beadographer. We hope you enjoy using this app!",
    "fr": "Ces ressources pourront vous aider à bien démarrer avec Beadographer. Nous espérons que cette application vous satisfera.",
    "da": "Disse ressourcer vil hjælpe dig med at komme i gang med Beadographer. Vi håber du vil have glæde af at bruge dennne app!.",
    "ro": "Aceste resurse te vor ajuta să începi să folosești Beadographer. Sperăm să îți facă plăcere să folosești această aplicație!"
  },
  {
    "desc": "learn to use beadographer title",
    "en": "Learn to use Beadographer",
    "fr": "Apprendre à utiliser Beadographer",
    "da": "Lær at bruge Beadographer",
    "ro": "Învață să folosești Beadographer"
  },
  {
    "desc": "learning option 1",
    "en": "Watch our Youtube tutorials",
    "fr": "Regardez nos tutoriels sur YouTube",
    "da": "Se vores Youtube videoer.",
    "ro": "Urmărește tutorialele pe Youtube"
  },
  {
    "desc": "learning option 2",
    "en": "Read the user guide",
    "fr": "Lisez le mode d'emploi",
    "da": "Læs brugervejledningen",
    "ro": "Citește ghidul utilizatorului"
  },
  {
    "desc": "learning option 3",
    "en": "Join the Beadographer Facebook Group and find out what people are making.",
    "fr": "Rejoignez notre groupe Beadographer sur Facebook et regardez ce que font les autres.",
    "da": "Meld dig ind i Beadographer Facebook gruppen og se hvad andre laver.",
    "ro": "Alătură-te Grupului de Facebook Beadographer și află ce fac oamenii."
  },
  {
    "desc": "become a member title",
    "en": "Become a member",
    "fr": "Devenez membre",
    "da": "Bliv medlem",
    "ro": "Devino membru"
  },
  {
    "desc": "join beadographer intro",
    "en": "Joining Beadographer as a member gives you access to the membership version. This lets you:",
    "fr": "Devenir membre de Beadographer vous permet d'utiliser la version réservée aux membres, qui permet :",
    "da": "Ved at tilmelde dig Beadographer som medlem vil du på adgang til medlemsversionen af app'en. Dette vil lade dig:",
    "ro": "Alăturându-te ca membru Beadographer vei primi acces la versiunea premium. Asta îți va permite: "
  },
  {
    "desc": "membership benefit 1",
    "en": "Load and save your projects.",
    "fr": "Charger et sauvegarder vos projets.",
    "da": "Hente og gemme dine projekter.",
    "ro": "Să îți încarci și să îți salvezi proiectele tale."
  },
  {
    "desc": "membership benefit 2",
    "en": "Change the size, library, and pattern of your projects.",
    "fr": "Changer la taille, le motif de vos projets et le catalogue de perles.",
    "da": "Ændre størrelse, kartotek og mønster på dine projekter",
    "ro": "Să schimbi mărimea, librăria de mărgele și schemele proiectelor tale."
  },
  {
    "desc": "membership benefit 3",
    "en": "Load and save your palettes.",
    "fr": "Charger et sauvegarder vos palettes.",
    "da": "Hente og gemme dine paletter",
    "ro": "Să îți încarci și să îți salvezi paletele de culori."
  },
  {
    "desc": "membership benefit 4",
    "en": "Share your projects with other people.",
    "fr": "Partager vos projets avec d'autres.",
    "da": "Dele dine projekter med andre",
    "ro": "Să distribui proiectele tale altor persoane."
  },
  {
    "desc": "membership benefit 5",
    "en": "Export your projects to PDF.",
    "fr": "Exporter vos projets en PDF",
    "da": "Eksportere dine projekter til PDF",
    "ro": "Să îți exporți proiectele în format PDF."
  },
  {
    "desc": "membership benefit 6",
    "en": "Load and adapt any project from the Beadographer Pattern Library.",
    "fr": "Utiliser et modifier les projets de la bibliothèque de diagrammes Beadographer.",
    "da": "Hente og tilpasse ethvert projekt fra Beadographers mønster biblioteket.",
    "ro": "Să încarci și să adaptezi orice proiect din Librăria de modele Beadographer."
  },
  {
    "desc": "membership price info",
    "en": "Membership costs $14.99 / year.",
    "fr": "L'abonnement annuel coûte 14,99 dollars US.",
    "da": "Medlemsskab koster $14.99 pr.år",
    "ro": "Abonamentul costă 14.99 dolari/an."
  },
  {
    "desc": "sign up button",
    "en": "Sign up now",
    "fr": "Abonnez-vous maintenant",
    "da": "Tilmeld dig nu",
    "ro": "Înscrie-te acum"
  },
  {
    "desc": "having problems title",
    "en": "Having problems?",
    "fr": "Vous rencontrez une difficulté ?",
    "da": "Har du problemer?",
    "ro": "Întâmpini probleme?"
  },
  {
    "desc": "get in touch info",
    "en": "Get in touch with us with the contact form. We will be in touch with you as soon as we can!",
    "fr": "Faites-nous en part via le formulaire de contact, nous vous répondrons dès que possible !",
    "da": "Kontakt os med kontaktformularen. Vi vil tage kontakt med dig så hurtigt som muligt!",
    "ro": "Ia legătura cu noi folosind formularul de contact. Te vom contacta cât mai curând posibil!"
  },
  {
    "desc": "get in touch button",
    "en": "Get in touch",
    "fr": "Contactez-nous",
    "da": "Kontakt os",
    "ro": "Ia legătura cu noi"
  },
  {
    "desc": "about beadographer title",
    "en": "About Beadographer",
    "fr": "À propos de Beadographer",
    "da": "Om Beadographer",
    "ro": "Despre Beadographer"
  },
  {
    "desc": "about beadographer info",
    "en": "Visit our website to learn more about the app, the developers, and future releases of the app.",
    "fr": "Visitez notre site web pour en savoir plus sur l'application, ses développeurs et les évolutions futures.",
    "da": "Besøg vores hjemmeside for at lære mere om app'en, udviklerne og fremtidige opdateringer af app'en.",
    "ro": "Vizitează website-ul nostru pentru a afla mai multe despre aplicație, dezvoltatori și versiunile viitoare ale aplicației."
  },
  {
    "desc": "visit our website button",
    "en": "Visit our website",
    "fr": "Visitez notre site web",
    "da": "Besøg vores hjemmeside",
    "ro": "Vizitează website-ul nostru"
  },
  {
    "desc": "unknown file date",
    "en": "unknown",
    "fr": "inconnu",
    "da": "ukendt",
    "ro": "necunoscut"
  },
  {
    "desc": "project saved to cloud",
    "en": "Project saved to cloud",
    "fr": "Projet enregistré dans le cloud",
    "da": "Projekt gemt i skyen",
    "ro": "Proiect salvat în cloud"
  },
  {
    "desc": "cloud tool tip",
    "en": "Cloud",
    "fr": "Cloud",
    "da": "Sky",
    "ro": "Cloud"
  },
  {
    "desc": "rotator tool tip",
    "en": "Rotator",
    "fr": "Rotateur",
    "da": "Rotator",
    "ro": "Unealta de rotire "
  },
  {
    "desc": "done",
    "en": "Done",
    "fr": "OK",
    "da": "Færdig",
    "ro": "Terminat"
  },
  {
    "desc": "add tint",
    "en": "Add tint",
    "fr": "Ajouter une teinte",
    "da": "Tilføj farvetone",
    "ro": "Adaugă nuanță"
  },
  {
    "desc": "product",
    "en": "Product",
    "fr": "Produit",
    "da": "Produkt",
    "ro": "Produs"
  },
  {
    "desc": "details",
    "en": "Details",
    "fr": "Détails",
    "da": "Detaljer",
    "ro": "Detalii"
  },
  {
    "desc": "stock",
    "en": "Stock",
    "fr": "Stock",
    "da": "Lager",
    "ro": "Stoc"
  },
  {
    "desc": "edit collection",
    "en": "Edit Collection",
    "fr": "Modifier la collection",
    "da": "Rediger Samling",
    "ro": "Editează colecția"
  },
  {
    "desc": "new collection",
    "en": "New Collection",
    "fr": "Nouvelle Collection",
    "da": "Ny Samling",
    "ro": "Colecție nouă"
  },
  {
    "desc": "back",
    "en": "Back",
    "fr": "Retour",
    "da": "Tilbage",
    "ro": "Înapoi"
  },
  {
    "desc": "you have no collections yet",
    "en": "You have no collections yet",
    "fr": "Vous n'avez aucune collection",
    "da": "Du har ingen samlinger",
    "ro": "Nu ai nici o colecție deocamdată"
  },
  {
    "desc": "showing all projects with tag",
    "en": "Showing all projects with tag",
    "fr": "Affichage de tous les projets avec tag",
    "da": "Viser alle projekter med tag",
    "ro": "Arată toate proiectele cu etichete"
  },
  {
    "desc": "clear tag filter",
    "en": "Clear tag filter",
    "fr": "Effacer le filtre de balises",
    "da": "Ryd tagfilter",
    "ro": "Șterge filtrul etichetelor"
  },
  {
    "desc": "no tags",
    "en": "No tags",
    "fr": "Aucune balise",
    "da": "Ingen tags",
    "ro": "Fără etichete "
  },
  {
    "desc": "download project",
    "en": "Download Project",
    "fr": "Télécharger le projet",
    "da": "Download projekt",
    "ro": "Descarcă proiectul"
  },
  {
    "desc": "copy front to back",
    "en": "Copy front to back",
    "fr": "Copie recto verso",
    "da": "Kopier forfra til bagside",
    "ro": "Copiază din față în spate "
  },
  {
    "desc": "update",
    "en": "Update",
    "fr": "Mettre à jour",
    "da": "Opdatere",
    "ro": "Actualizează"
  },
  {
    "desc": "open",
    "en": "Open",
    "fr": "Ouvrir",
    "da": "Åbne",
    "ro": "Deschide"
  },
  {
    "desc": "edit",
    "en": "Edit",
    "fr": "Modifier",
    "da": "Redigere",
    "ro": "Editează"
  },
  {
    "desc": "enter hex code",
    "en": "Enter hex code",
    "fr": "Entrer le code hexadécimal",
    "da": "Indtast hex-kode",
    "ro": "Introdu codul hex"
  },
  {
    "desc": "scroll to origin tool tip",
    "en": "Scroll to origin",
    "fr": "Faites défiler jusqu'à l'origine",
    "da": "Rul til oprindelse",
    "ro": "Derulează la original"
  },
  {
    "desc": "active swatch",
    "en": "Active swatch",
    "fr": "Style actif",
    "da": "Aktiv farve",
    "ro": "Mostră activă"
  },
  {
    "desc": "color match",
    "en": "Color match",
    "fr": "Correspondance des couleurs",
    "da": "Farve match",
    "ro": "Potrivirea culorilor"
  },
  {
    "desc": "new swatch",
    "en": "New swatch",
    "fr": "Nouvel échantillon",
    "da": "Ny farve",
    "ro": "Mostră nouă de mărgele"
  },
  {
    "desc": "edit library bead",
    "en": "Edit library bead",
    "fr": "Modifier la perle de la catalogue de perles",
    "da": "Rediger katalogsperle",
    "ro": "Editează librăria de mărgele"
  },
  {
    "desc": "reset swatch button",
    "en": "Reset",
    "fr": "Réinitialiser",
    "da": "Gendan",
    "ro": "Resetează"
  },
  {
    "desc": "all",
    "en": "All",
    "fr": "Tout",
    "da": "Alle",
    "ro": "Toate"
  },
  {
    "desc": "all in stock",
    "en": "All in stock",
    "fr": "Tout en stock",
    "da": "Alt på lager",
    "ro": "Toate din stoc"
  },
  {
    "desc": "add to collection",
    "en": "Add to collection",
    "fr": "Ajouter à la collection",
    "da": "Tilføj til samling",
    "ro": "Adaugă la colecție"
  },
  {
    "desc": "current palette",
    "en": "Current Palette",
    "fr": "Palette actuelle",
    "da": "Nuværende palette",
    "ro": "Paleta de culori curentă"
  },
  {
    "desc": "collections",
    "en": "Collections",
    "fr": "Collections",
    "da": "Samlinger",
    "ro": "Colecții"
  },
  {
    "desc": "clone mode",
    "en": "Clone mode",
    "fr": "Mode clonage",
    "da": "Klontilstand",
    "ro": "Modul clonă"
  },
  {
    "desc": "template options area",
    "en": "Template",
    "fr": "Modèle",
    "da": "Skabelon",
    "ro": "Șablon"
  },
  {
    "desc": "insert shortcode",
    "en": "Insert Shortcode",
    "fr": "Insérer un shortcode",
    "da": "Indsæt kortkode",
    "ro": "Introdu codul scurt"
  },
  {
    "desc": "my saved templates",
    "en": "My saved templates",
    "fr": "Mes modèles enregistrés",
    "da": "Mine gemte skabeloner",
    "ro": "Șabloanele mele salvate"
  },
  {
    "desc": "save template",
    "en": "Save template",
    "fr": "Enregistrer le modèle",
    "da": "gem skabelon",
    "ro": "Salvează șablonul"
  },
  {
    "desc": "free version",
    "en": "Free Version",
    "fr": "Version gratuite",
    "da": "Gratis version",
    "ro": "Versiune gratuită"
  },
  {
    "desc": "error saving settings",
    "en": "Error saving settings",
    "fr": "Erreur lors de l'enregistrement des paramètres",
    "da": "Fejl under lagring af indstillinger",
    "ro": "Eroare la salvarea setărilor"
  },
  {
    "desc": "error saving project",
    "en": "Error saving project",
    "fr": "Erreur lors de l'enregistrement du projet",
    "da": "Der opstod en fejl under lagring af projektet",
    "ro": "Eroare la salvarea proiectului"
  },
  {
    "desc": "front copied to back",
    "en": "Front copied to back",
    "fr": "Avant copié à l'arrière",
    "da": "Forside kopieret til bagside",
    "ro": "Față copiată în spate"
  },
]